import { useEffect } from "react";
import { SnackbarProvider } from "notistack";
import { connect, Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { store } from "./data/redux/store";
import CustomFullScreenLoader from "./presentation/components/customFullScreenLoader";
import Layout from "./presentation/layout/index";
import Router from "./routes";
import history from "./routes/history";

function App() {
  return (
    <Provider store={store}>
      <CustomFullScreenLoader />
      <SnackbarProvider
        maxSnack={1}
        autoHideDuration={3000}
        auto
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <BrowserRouter history={history}>
          <Layout>
            <Router />
          </Layout>
        </BrowserRouter>
      </SnackbarProvider>
    </Provider>
  );
}

export default App;
